import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _PROPS_BY_TRANSITION;
import { BLUR_ANIMATION, BLUR_IN_TRANSITION, BLUR_OUT_TRANSITION, HEIGHT_TRANSITION } from './types/animation.types';
export var DEFAULT_ANIMATION_DURATION = 250; // ms
export var DEFAULT_ANIMATION_DELAY = 25; // ms

export var DEFAULT_BLUR_ANIMATION_PROPS = {
  opacity: 0.5,
  blur: '2px'
};
export var DEFAULT_HEIGHT_TRANSITION = {
  height: 'auto',
  overflow: 'hidden'
};
export var PROPS_BY_TRANSITION = (_PROPS_BY_TRANSITION = {}, _defineProperty(_PROPS_BY_TRANSITION, BLUR_OUT_TRANSITION, DEFAULT_BLUR_ANIMATION_PROPS), _defineProperty(_PROPS_BY_TRANSITION, BLUR_IN_TRANSITION, DEFAULT_BLUR_ANIMATION_PROPS), _defineProperty(_PROPS_BY_TRANSITION, HEIGHT_TRANSITION, DEFAULT_HEIGHT_TRANSITION), _PROPS_BY_TRANSITION);
export var ANIMATION_STATUS = {
  PRE_ANIMATING: 'preAnimating',
  ANIMATING: 'animating',
  NO_ANIMATION: 'noAnimation'
};
export var TRANSITIONS_BY_ANIMATION = _defineProperty({}, BLUR_ANIMATION, [BLUR_OUT_TRANSITION, BLUR_IN_TRANSITION]);
export var ON_REVEAL = 'onReveal';
export var ON_OPTIONS = [ON_REVEAL];